import { InjectionToken } from "@angular/core";

export const AOH_BASE_URL    = new InjectionToken(`aop base url`);
export const ENTITLE_BASE_URL = new InjectionToken(`base url for entilement`);
export const brain_base_url  = new InjectionToken(`base url for brain`);

